import { z } from "zod";

export const addressDefaults = {
  street: "",
  city: "",
  zip_code: "",
  province: "",
  country: "",
}

export const contactDefaults = {
  name: "",
  vat: "",
  email: "",
  phone: "",
  address: {
    ...addressDefaults,
  },
}

export const brandDefaults = {
  name: "",
  /* contact: {
    ...contactDefaults,
  }, */
};

export const addressSchema = z.object({
  street: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
  city: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
  zip_code: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
  province: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
  country: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
}).default({ ...addressDefaults });

export const contactSchema = z.object({
  name: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
  vat: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
  email: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
  phone: z
    .string({ required_error: "La marca es obligatoria" })
    .trim()
    .min(2, "La marca debe contener al menos 2 carácteres")
    .default(""),
  address: addressSchema.default(addressDefaults),
}).default({ ...contactDefaults });

export const brandSchema = z.object({
  name: z
    .string({ required_error: "key_brand_name_required" })
    .trim()
    .superRefine((val, ctx) => {
      if (val.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "key_brand_name_required",
        });
      } else if (val.length < 2) {
        ctx.addIssue({
          code: z.ZodIssueCode.too_small,
          minimum: 2,
          type: "string",
          inclusive: true,
          message: "key_brand_name_min_2_chars",
        });
      }
    }),
  //contact: contactSchema.default(contactDefaults),
})
.default({ ...brandDefaults });

